<template>
  <div class="yazdirtable Aski">

    <el-row :gutter="24" class="mb-3">

      <el-col :span="21">
        <h5 class="text-left">{{ Fatura.BinaAdi }} BİNASI<br>ASKI LİSTESİ</h5>
      </el-col>

      <el-col :span="3">

        <img v-if="Hesap_id==6" src="https://cdn.mudu.pro/Design/yapifen.svg" width="100%">
        <img v-if="Hesap_id==7" src="https://www.websitecim.com/imza/doruk.jpg" width="100%">
      </el-col>
    </el-row>
    <table class="table table-bordered">
      <thead>
      <tr>
        <th colspan="9" class="text-center">FATURA/DÖNEM BİLGİLERİ</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <small class="d-block">Son Ödeme Tarihi</small>
          <b style="font-size: 12px">{{ Fatura.starih }}</b>
        </td>
        <td>
          <small class="d-block">Fatura Tarihi</small>
          <b style="font-size: 12px">{{ Fatura.ftarih }}</b>
        </td>
        <td class="text-right">
          <small class="d-block">Hesaplanan Enerji</small>
          <b style="font-size: 12px">{{ AltToplam.Hesap }} <sup>kWh</sup></b>
        </td>
        <td class="text-right">
          <small class="d-block">Hesaplanan Enerji Birim</small>
          <b style="font-size: 12px">{{ AltToplam.Birim }} <sup>TL</sup></b>
        </td>
        <td class="text-right">
          <small class="d-block">Toplam Kapalı Alan</small>
          <b style="font-size: 12px">{{ AltToplam.KapaliAlan }}<sup>m2</sup></b>
        </td>
        <td class="text-right" v-if="Fatura.SicakSu">
          <small class="d-block">Şebeke Suyu</small>
          <b style="font-size: 12px">{{ Fatura.SuBirim }}<sup>TL</sup></b>
        </td>
        <td class="text-right" v-if="Fatura.SicakSu">
          <small class="d-block">Şebeke Suyu Isıtma</small>
          <b style="font-size: 12px">{{ AltToplam.sTuketim }}<sup>TL</sup></b>
        </td>

        <td class="text-right" v-if="Fatura.eAciklama">
          <small class="d-block">{{ Fatura.eAciklama }}</small>
          <b style="font-size: 12px"> {{ Fatura.eTutar }}<sup>TL</sup></b>
        </td>
        <td class="text-right" v-if="Fatura.Tur==1">
          <small class="d-block">Ortak Alan</small>
          <b style="font-size: 12px"><sup>%{{ Fatura.oAlan }}</sup> {{ AltToplam.oAlan }}<sup>TL</sup></b>
        </td>
        <td class="text-right" v-if="Fatura.Tur==2">
          <small class="d-block">Su Ortak Alan</small>
          <b style="font-size: 12px"><sup>%{{ Fatura.oAlan }}</sup> {{ AltToplam.SuOrtak }}<sup>TL</sup></b>
        </td>
        <td class="text-right">
          <small class="d-block">Fatura Tutarı</small>
          <b style="font-size: 12px">{{ Fatura.tutar }}<sup>TL</sup></b>
        </td>
      </tr>
      </tbody>
    </table>

    <table class="table table-bordered">
      <thead>
      <tr>
        <th colspan="3" class="text-center">Bilgi</th>
        <th :colspan="Fatura.MuafPay?6:5" v-if="Fatura.Tur==1" class="text-center">Isınma</th>
        <th :colspan="Fatura.Tur==2?6:5" v-if="Fatura.SicakSu" class="text-center">Sıcak Su</th>
        <th :colspan="Fatura.eTutar?3:2" class="text-center"></th>
      </tr>
      <tr>
        <th>No</th>
        <th>İsim Soyisim</th>
        <th>M2</th>

        <th class="text-right" v-if="Fatura.Tur==1">İlk</th>
        <th class="text-right" v-if="Fatura.Tur==1">Son</th>
        <th class="text-right" v-if="Fatura.Tur==1">Fark</th>
        <!--        <th class="text-right" v-if="Fatura.Tur==1">Manipülasyon</th>-->
        <th class="text-right" v-if="Fatura.Tur==1">Tüketim Bedeli</th>
        <th class="text-right" v-if="Fatura.Tur==1">Ortak Alan Bedeli</th>
        <th class="text-right" v-if="Fatura.MuafPay">Muaf Mesken Payı</th>

        <th class="text-right" v-if="Fatura.SicakSu">İlk</th>
        <th class="text-right" v-if="Fatura.SicakSu">Son</th>
        <th class="text-right" v-if="Fatura.SicakSu">Fark</th>
        <th class="text-right" v-if="Fatura.SicakSu">Tüketim Bedeli</th>
        <th class="text-right" v-if="Fatura.Tur==2">Ortak Alan Bedeli</th>

        <th class="text-right" v-if="Fatura.SicakSu">Şebeke Bedeli</th>
        <th class="text-right" v-if="Fatura.eTutar>0">{{ Fatura.eAciklama }}</th>
        <th class="text-right">Okuma Ücreti</th>
        <th class="text-right">Ödenecek Tutar</th>

      </tr>
      </thead>
      <tbody>
      <tr v-for="f in FaturaDokum">
        <td>{{ f.kNo }}</td>
        <td>{{ f.AdSoyad }}</td>
        <td>{{ f.m2 }}<sup>m2</sup></td>

        <td class="text-right" v-if="Fatura.Tur==1">{{ f.KalSayac.Ilk }}<sup>kWh</sup></td>
        <td class="text-right" v-if="Fatura.Tur==1">{{ f.KalSayac.Son }}<sup>kWh</sup></td>
        <td class="text-right" v-if="Fatura.Tur==1"> {{ f.KalSayac.Fark }}<sup>kWh</sup> <i v-if="f.UyariIcon"
                                                                                            :class="f.UyariIcon"></i>
        </td>
        <!--        <td class="text-right" v-if="Fatura.Tur==1">{{ f.Derece }}<sup>kWh</sup></td>-->
        <td class="text-right" v-if="Fatura.Tur==1">{{ f.tUcret }}<sup>TL</sup></td>
        <td class="text-right" v-if="Fatura.Tur==1">{{ f.oAlan }}<sup>TL</sup></td>
        <td class="text-right" v-if="Fatura.MuafPay">{{ f.MuafUcret }}<sup>TL</sup></td>

        <td class="text-right" v-if="Fatura.SicakSu">{{ (f.SuSayac.Ilk / 1000).toFixed(2) }}<sup>M3</sup></td>
        <td class="text-right" v-if="Fatura.SicakSu">{{ (f.SuSayac.Son / 1000).toFixed(2) }}<sup>M3</sup></td>
        <td class="text-right" v-if="Fatura.SicakSu">{{ (f.SuSayac.Fark / 1000).toFixed(2) }}<sup>M3</sup></td>
        <td class="text-right" v-if="Fatura.SicakSu">{{ f.sTuketim }}<sup>TL</sup></td>
        <td class="text-right" v-if="Fatura.Tur==2">{{ f.SuOrtak }}<sup>TL</sup></td>

        <td class="text-right" v-if="Fatura.SicakSu">{{ f.sSebeke }}<sup>TL</sup></td>
        <td class="text-right" v-if="Fatura.eTutar>0">{{ f.eTutar }}<sup>TL</sup></td>
        <td class="text-right">{{ f.Okuma }}<sup>TL</sup></td>
        <td class="text-right">{{ f.Odenecek }}<sup>TL</sup></td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <th colspan="6" class="text-right"></th>
        <!--        <th class="text-right" v-if="Fatura.Tur==1">{{ AltToplam.Enerji }}<sup>kWh</sup></th>-->
        <!--        <th class="text-right" v-if="Fatura.Tur==1">{{ AltToplam.Derece }}<sup>kWh</sup></th>-->
        <th class="text-right" v-if="Fatura.Tur==1">{{ AltToplam.tUcret }}<sup>TL</sup></th>
        <th class="text-right" v-if="Fatura.Tur==1">{{ AltToplam.oAlan }}<sup>TL</sup></th>
        <th class="text-right" v-if="Fatura.MuafPay">{{ AltToplam.MuafUcret }}<sup>TL</sup></th>
        <th colspan="3" class="text-right" v-if="Fatura.Tur==1 & Fatura.SicakSu"></th>
        <th class="text-right" v-if="Fatura.SicakSu">{{ AltToplam.sTuketim }}<sup>TL</sup></th>
        <th class="text-right" v-if="Fatura.Tur==2">{{ AltToplam.SuOrtak }}<sup>TL</sup></th>

        <th class="text-right" v-if="Fatura.SicakSu">{{ AltToplam.sSebeke }}<sup>TL</sup></th>
        <th class="text-right" v-if="Fatura.eTutar>0">{{ Fatura.eTutar }}<sup>TL</sup></th>
        <th class="text-right">{{ AltToplam.Okuma }}<sup>TL</sup></th>
        <th class="text-right">{{ AltToplam.Odenecek }}<sup>TL</sup></th>
      </tr>
      </tfoot>
    </table>
    <p style="font-size: 10px;text-align: center">Bu belge ve hesaplaması 14 Nisan 2008 tarihli resmi gazetede
      yayınlanan 26847
      sayılı
      "Merkez Isınma ve Sıhhi
      Sıcak Su Sistemlerinde Merkez Isınma ve Sıhhi Sıcak Su Giderlerinin Paylaştırılmasına İlişkin Yönetmelik"
      esaslarına göre düzenlenmiştir.</p>
    <p style="font-size: 10px;text-align: center" v-if="Hesap_id==6">
      BU DÖKÜMAN 6698 SAYILI KİŞİSEL VERİLERİN KORUNMA KANUNU KAPSAMINDA 3.KİŞİLERLE PAYLAŞILMAYACAKTIR.<br>
      YAPIFEN ENERJİNİN 3. KİŞİLERLE PAYLAŞIMDAN DOĞACAK HİÇBİR HUKUKİ, CEZA-İ VE İDARİ SORUMLULUĞU YOKTUR.
    </p>
  </div>
</template>

<script>
export default {
  props: ['Fatura', 'AltToplam', 'FaturaDokum', 'Hesap_id']
}
</script>

<style scoped>
.yazdirtable {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Tab/SayacAskiListesi.vue